import contactsServiceGen from "./generated/contactsServiceGen";

class contactsService extends contactsServiceGen {
}

export default contactsService;